import { createType } from '../../../Utils';

const actionName = 'MEDIA';

export const SET_WEB_VIEW = createType.customAction(actionName, 'SET_WEB_VIEW');